/**
 * Persian / local slot datetime helpers for Matchmaking V2 intake.
 * Uses Intl (fa-IR Persian calendar) so Node unit tests need no moment stub.
 */

function toFaDigitsLocal(value) {
  return String(value).replace(/\d/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'[digit])
}

export function browserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
}

export function displayTimeZone() {
  try {
    const session = typeof sessionStorage !== 'undefined' && JSON.parse(sessionStorage.getItem('rb_intake_match') || 'null')
    const zone = session && session.displayTimezone
    if (zone) { new Intl.DateTimeFormat('en', {timeZone: zone}); return zone }
  } catch (e) { /* Invalid or unavailable presentation cache: use the browser zone. */ }
  return browserTimeZone()
}

/**
 * @param {string|null|undefined} iso
 * @param {string} [lang]
 * @returns {{dateLabel: string, timeLabel: string, combinedLabel: string}}
 */
export function formatSlotDateTime(iso, lang = 'fa', timeZone = displayTimeZone()) {
  const raw = String(iso || '').trim()
  if (!raw) {
    return {dateLabel: '', timeLabel: '', combinedLabel: ''}
  }
  const d = new Date(raw)
  if (Number.isNaN(d.getTime())) {
    return {dateLabel: raw, timeLabel: '', combinedLabel: raw}
  }

  if (lang === 'en') {
    const dateLabel = new Intl.DateTimeFormat('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'short',
      timeZone,
    }).format(d)
    const timeLabel = new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone,
    }).format(d)
    return {
      dateLabel,
      timeLabel,
      combinedLabel: dateLabel + ' · ' + timeLabel + ' (' + timeZone + ')',
    }
  }

  const dateLabel = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone,
  }).format(d)
  const timeLabel = toFaDigitsLocal(new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone,
  }).format(d))

  return {
    dateLabel,
    timeLabel,
    combinedLabel: dateLabel + ' · ' + timeLabel + ' (' + timeZone + ')',
  }
}
